import { useNavigate } from "react-router-dom";

import { Dialog, SelectionMode } from "@bps/fluent-ui";

import { SelectSoftwarePackage } from "../../../rings/rollout-package/add/SelectSoftwarePackage";
import { SelectSoftwarePackageFormValues } from "../../../rings/rollout-package/add/selectSoftwarePackageUtils";

interface SelectSoftwarePackageBulkDialogProps {
  onDismiss: () => void;
  setSelectedSoftwarePackage: React.Dispatch<
    React.SetStateAction<SelectSoftwarePackageFormValues>
  >;
}

export const SelectSoftwarePackageBulkDialog: React.FC<SelectSoftwarePackageBulkDialogProps> = ({
  onDismiss,
  setSelectedSoftwarePackage,
  ...props
}) => {
  const navigate = useNavigate();
  const onAdd = (newPackages: SelectSoftwarePackageFormValues[]) => {
    setSelectedSoftwarePackage(newPackages[0]);
    navigate("/system/plt/bulk-actions");
  };

  return (
    <Dialog
      dialogContentProps={{
        showCloseButton: true,
        title: "Select Software Package"
      }}
      minWidth="90%"
      maxWidth="90%"
      onDismiss={onDismiss}
      hidden={false}
      {...props}
    >
      <SelectSoftwarePackage
        onDismiss={onDismiss}
        onAdd={onAdd}
        selectionMode={SelectionMode.single}
      />
    </Dialog>
  );
};
